/**
 * Single "Taxes & Fees" figure shown to customers.
 *
 * Used only when the brand ticks the `combine_taxes_and_fees` CMS checkbox
 * (read with `getFlag` from ManageKeysProvider); unticked — the default — the
 * summaries itemize the service fee, Bodhi Protect and sales tax as before.
 * The combined line's label comes from the `taxes_and_fees_label` CMS text key
 * (default "Taxes & Fees") and is only editable in combined mode.
 * `prices.tax` is already calculated on a base that includes the service fee,
 * and Bodhi Protect is added straight to `prices.total` (only when the customer
 * has not opted out), so this sum keeps the Total unchanged.
 *
 * The API mirrors the same flag for the confirmation email / PDF / alerts
 * (`utils/reservationTotals.ts` + `utils/cmsFlags.ts` in bohdisys-api).
 */
export const getTaxesAndFees = (
  prices?: { tax?: number; service_fee?: number } | null,
  reservation?: { bodhi_protect_opted_out?: boolean | number; bodhi_protect_price?: number } | null
) => {
  const bodhiProtect = reservation?.bodhi_protect_opted_out
    ? 0
    : Number(reservation?.bodhi_protect_price) || 0;

  return (Number(prices?.tax) || 0) + (Number(prices?.service_fee) || 0) + bodhiProtect;
};
